






















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import { FileType } from '@/models/file-type';
import { PayServiceModel } from '@/models/payservice';
import utility from '@/utility/utility';

@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class PayServiceInfo extends Vue {
    @Prop({ default: () => new PayServiceModel() })
    private payservice!: PayServiceModel;

    @Prop({ default: () => [] })
    private listImages!: FileType[];

    private index = null;

    get imgs() {
        return this.listImages.map(x => x.src);
    }

    triggerFileInput() {
        (this.$refs.fileInput as any).click();
    }

    onChangeFile(event: any) {
        const onLoad = (file: any, id: number) => {
            const reader = new FileReader();
            reader.onload = e => {
                const arrFileType = file.name.split('.');
                this.listImages.push({
                    fileName: `${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`,
                    src: reader.result || undefined,
                    file,
                    id
                });
            };
            reader.readAsDataURL(file);
        };

        if (event.target.files && event.target.files[0]) {
            let i = 1;
            const files = event.target.files;
            for (const file of files) {
                onLoad(file, i);
                i++;
            }
        }
    }

    onDeleteImage(id: number) {
        const index = this.listImages.findIndex(x => x.id === id);
        if (index > -1) {
            this.listImages.splice(index, 1);
        }
    }

    showGallery(idx: any) {
        this.index = idx;
    }
}
